import { Button } from "react-bootstrap";
import ImageCarousel from "../ImageCarousel";

export default function MatchFixtures() {
  return (
    <div className="card-container">
      <p>
        सेपक टाकरा वर्ल्ड कप 2025 का आयोजन भारत के बिहार में 20 से 25 मार्च तक
        होने जा रहा है, जो खेल प्रेमियों के लिए एक रोमांचक अवसर लेकर आया है।
        अंतरराष्ट्रीय सेपक टाकरा महासंघ (ISTAF) द्वारा आयोजित यह प्रतिष्ठित
        टूर्नामेंट दुनिया भर के शीर्ष खिलाड़ियों को एक मंच पर लाएगा। इसमें पुरुष
        और महिला वर्गों में विभिन्न इवेंट्स जैसे क्वाड्रेंट, डबल, मिक्स्ड, और
        रेगु शामिल होंगे सेपक टाकरा के प्रशंसकों के लिए यह एक शानदार मौका है! इस
        टूर्नामेंट का पूरा शेड्यूल आपको इस पेज पर मिल जाएगा। जिसमें विभिन्न
        कैटेगरी जैसे क्वाड्रंट, डबल्स, रेगु और मिक्स्ड इवेंट्स के मैचों की तिथि,
        समय और मुकाबले की जानकारी दी गई है। यहां आप आसानी से अपने पसंदीदा मैचों
        की डिटेल्स देख सकते हैं और टूर्नामेंट के हर रोमांचक मोमेंट का आनंद ले
        सकते हैं। नीचे दिए गए शेड्यूल में सभी मुकाबलों की पूरी जानकारी देखें और
        अपनी पसंदीदा टीमों को सपोर्ट करने के लिए तैयार हो जाएं!
      </p>
      <br />
      <div className="d-flex justify-content-center">
        <Button
          variant="primary"
          onClick={() =>
            window.open(
              // "pdf/events/ISW2025 - Bihar - Competition Schedule as of 19 March 2025 - as of 1300.pdf",
              "pdf/events/ISW2025 - Bihar - Competition Schedule as of 21 March 2025 - as of 1100.pdf",
              "_blank"
            )
          }
        >
          प्रतियोगिता कार्यक्रम देखें
        </Button>
      </div>
      <br />
      <ImageCarousel />
      {/* iframe not working on mobile browser */}
      {/* <div className="d-flex justify-content-center">
                  <iframe
                    src="pdf/events/ISW2025 - Bihar - Competition Schedule as of 19 March 2025 - as of 1300.pdf"
                    style={{ width: "100%", height: "500px", border: "none" }}
                    title="Competition Schedule"
                  ></iframe>
                  </div> */}
    </div>
  );
}
